export const environment = {
  production: true,
  baseUrl: "https://api.nsiainsurance.com",
  firebaseConfig: {
    // apiKey: "AIzaSyCQYiIqaa-2XBO0_efgTv533TpXjKiQGV0",
    // authDomain: "nsia-web.firebaseapp.com",
    // databaseURL: "https://nsia-web-default-rtdb.firebaseio.com",
    // projectId: "nsia-web",
    // storageBucket: "nsia-web.appspot.com",
    // messagingSenderId: "296710376456",
    apiKey: "AIzaSyDf-yyixLSEflitRX6JtIFBvu8PtEjjkVU",
    authDomain: "nsia-35d6c.firebaseapp.com",
    projectId: "nsia-35d6c",
    databaseURL: "https://nsia-35d6c-default-rtdb.firebaseio.com",
    storageBucket: "nsia-35d6c.firebasestorage.app",
    messagingSenderId: "604513255840",
    appId: "1:604513255840:web:e34cc0adeb9146dcfda4c5",
    measurementId: "G-FF5SKB9112" 
  }
};

